import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

import { LinkedPatientsComponent } from './reasons/linked-patients/linked-patients.component';
import { ReasonsNavigationComponent } from './reasons/reasons-navigation/reasons-navigation.component';
import { ReasonFormAttachmentComponent } from './reasons/reason-form/reason-form-attachment.component';
import { ReasonFormComponent } from './reasons/reason-form/reason-form.component';
import { ReasonFormDateComponent } from './reasons/reason-form/reason-form-date.component';
import { ReasonFormFreeTextComponent } from './reasons/reason-form/reason-form-free-text.component';
import { ReasonFormMultipleChoiceComponent } from './reasons/reason-form/reason-form-multiple-choice.component';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { AppointmentRequestsComponent } from '../home/appointment-requests/appointment-requests.component';
import { CancelledAppointmentRequestsComponent } from '../home/appointment-requests/cancelled-appointment-requests/cancelled-appointment-requests.component';
import { AppointmentRequestsService } from '../home/appointment-requests/appointment-requests.service';
import { RecallListService } from './../home/recall-list/recall-list.service';
import { AppointmentRequestCancelComponent } from '../home/appointment-requests/appointment-request-cancel.component';
import { RecallListComponent } from './../home/recall-list/recall-list.component';
import { AppointmentsConfirmationComponent } from './appointments/appointments-confirmation/appointments-confirmation.component';
import { AppointmentComponent } from './appointments/appointment/appointment.component';
import { AppointmentReminderComponent } from './appointments/appointments-reminder/appointments-reminder.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [
    ReasonsNavigationComponent,
    ReasonFormAttachmentComponent,
    ReasonFormComponent,
    ReasonFormDateComponent,
    ReasonFormFreeTextComponent,
    ReasonFormMultipleChoiceComponent,
    AppointmentRequestsComponent,
    CancelledAppointmentRequestsComponent,
    AppointmentRequestCancelComponent,
    RecallListComponent,
    TopNavigationComponent,
    LinkedPatientsComponent,
    AppointmentsConfirmationComponent,
    AppointmentComponent,
    AppointmentReminderComponent,
  ],
  providers: [
    AppointmentRequestsService,
    RecallListService,
  ],
  entryComponents: [
    ReasonsNavigationComponent,
    ReasonFormAttachmentComponent,
    ReasonFormComponent,
    ReasonFormDateComponent,
    ReasonFormFreeTextComponent,
    ReasonFormMultipleChoiceComponent,
    AppointmentRequestsComponent,
    CancelledAppointmentRequestsComponent,
    AppointmentRequestCancelComponent,
    RecallListComponent,
    TopNavigationComponent,
    LinkedPatientsComponent,
    AppointmentsConfirmationComponent,
  ],
})

export class MainModule { }



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/main.module.ts